var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800.05px",
    height: "660.35px",
    viewBox: "0 0 800.05 660.35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -819.2,
    x2: 819.2,
    spreadMethod: "pad",
    gradientTransform: "matrix(0 -0.36614990234375 0.366180419921875 0 400 301.2)",
    id: "gradient0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 819.2,
    cx: 0,
    cy: 0,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.160888671875 0 0 0.28076171875 419 420.75)",
    id: "gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 819.2,
    cx: 0,
    cy: 0,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.330718994140625 0 0 0.0676422119140625 438 475.7)",
    id: "gradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -819.2,
    x2: 819.2,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.02197265625 0 0 0.2086181640625 401 471.1)",
    id: "gradient3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "url(#gradient0)",
    d: "M733 77.4 L528.9 77.4 Q511.55 77.4 499.2 91.25 486.95 105.1 486.95 124.65 L486.95 393.85 Q486.95 413.4 499.2 427.2 511.55 441.1 528.9 441.1 L733 441.1 Q750.35 441.1 762.65 427.2 774.95 413.4 774.95 393.85 L774.95 124.65 Q774.95 105.1 762.65 91.25 750.35 77.4 733 77.4 M786 601.2 L786 488.05 Q785.8 477.95 780.1 470.8 774.15 463.3 765.75 463.3 L419 463.3 419 392.1 401 300.25 383 392.1 383 463.3 34.3 463.3 Q25.9 463.3 19.95 470.8 14 478.2 14 488.75 L14 601.2 0 601.2 0 1.25 400 1.25 800.05 1.25 800.05 601.2 786 601.2 M400 47.9 L400 1.25 400 47.9 M274.05 77.4 L69.95 77.4 Q52.6 77.4 40.25 91.25 28 105.1 28 124.65 L28 393.85 Q28 413.4 40.25 427.2 52.6 441.1 69.95 441.1 L274.05 441.1 Q291.4 441.1 303.7 427.2 316 413.4 316 393.85 L316 124.65 Q316 105.1 303.7 91.25 291.4 77.4 274.05 77.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#abd6fe",
    d: "M274.05 77.4 Q291.4 77.4 303.7 91.25 316 105.1 316 124.65 L316 393.85 Q316 413.4 303.7 427.2 291.4 441.1 274.05 441.1 L69.95 441.1 Q52.6 441.1 40.25 427.2 28 413.4 28 393.85 L28 124.65 Q28 105.1 40.25 91.25 52.6 77.4 69.95 77.4 L274.05 77.4 M733 77.4 Q750.35 77.4 762.65 91.25 774.95 105.1 774.95 124.65 L774.95 393.85 Q774.95 413.4 762.65 427.2 750.35 441.1 733 441.1 L528.9 441.1 Q511.55 441.1 499.2 427.2 486.95 413.4 486.95 393.85 L486.95 124.65 Q486.95 105.1 499.2 91.25 511.55 77.4 528.9 77.4 L733 77.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#3366cc",
    fillOpacity: 0.4980392156862745,
    d: "M419 463.3 L765.75 463.3 Q774.15 463.3 780.1 470.8 785.8 477.95 786 488.05 L786 601.2 786 635 Q786 640.95 784.1 645.9 L783.15 648.15 Q781.9 650.65 780.1 652.95 774.15 660.35 765.75 660.35 L34.3 660.35 Q25.9 660.35 19.95 652.95 18.1 650.65 16.9 648.15 L15.9 645.9 Q14.8 643.05 14.35 639.85 L14.05 636.85 14 635 14 601.2 14 488.75 Q14 478.2 19.95 470.8 25.9 463.3 34.3 463.3 L383 463.3 383 493.15 364 493.15 364 529.05 438 529.05 438 493.15 419 493.15 419 463.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "url(#gradient1)",
    d: "M419 463.3 L419 493.15 383 493.15 383 463.3 383 392.1 401 300.25 419 392.1 419 463.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "url(#gradient2)",
    d: "M419 493.15 L438 493.15 438 529.05 364 529.05 364 493.15 383 493.15 419 493.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#gradient3)",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M383 392.1 L401 300.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M400 1.25 L400 47.9 M400 0 L400 1.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#ff0000",
    d: "M411.6 418.5 L412.35 418.6 Q412.9 418.75 413.35 419.2 414.1 419.95 414.1 421 414.1 422 413.35 422.7 L413.25 422.8 Q412.55 423.5 411.6 423.5 410.55 423.45 409.8 422.7 409.05 422 409.1 421 409.05 419.95 409.8 419.2 410.55 418.45 411.6 418.5 M389.6 418.5 L390.4 418.6 Q390.9 418.75 391.35 419.2 392.1 419.95 392.1 421 392.1 422 391.35 422.7 L391.3 422.8 Q390.6 423.5 389.6 423.5 388.6 423.45 387.85 422.7 387.1 422 387.1 421 387.1 419.95 387.85 419.2 388.6 418.45 389.6 418.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#00ff00",
    d: "M401.4 419.6 L402.35 420.2 Q403.1 420.95 403.15 421.95 403.1 423 402.35 423.7 L402.3 423.8 Q401.6 424.45 400.65 424.45 399.6 424.45 398.85 423.7 398.1 423 398.15 421.95 398.1 420.95 398.85 420.2 399.6 419.45 400.65 419.45 L401.4 419.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.351d478f1d174496883aeb99153f3a94.svg";
export { ForwardRef as ReactComponent };